module.exports = __webpack_public_path__ + "img/enterprise.63a8044c.svg";